export default {
	SMALL_SCREEN_WIDTH: 750,
	MEDIUM_SCREEN_WIDTH: 992,
	LARGE_SCREEN_WIDTH: 1200
}
